import { css } from 'styled-components';

export const getFilterByType = (type?: string) => {
  switch (type) {
    case 'forests':
      return css`
        filter: invert(50%) sepia(34%) saturate(600%) hue-rotate(55deg) brightness(105%)
          contrast(95%);
      `;
    case 'factories':
      return css`
        filter: invert(60%) sepia(10%) saturate(500%) hue-rotate(180deg) brightness(110%)
          contrast(95%);
      `;
    default:
      return css`
        filter: invert(60%) sepia(77%) saturate(547%) hue-rotate(349deg) brightness(94%)
          contrast(100%);
      `;
  }
};
